/* Filter choices survive Shopify's replacement of the variant picker. */
if (!customElements.get('variant-stock-filter')) {
  const selections = new Map();
  customElements.define('variant-stock-filter', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-stock-filter-select]');
      this.labels = Array.from(this.select.options, option => [option.value, option.textContent]);
      this.onChange = event => {
        event.stopPropagation(); // A stock filter is not a product option.
        selections.set(this.dataset.key, this.select.value);
        this.apply();
      };
      this.addEventListener('change', this.onChange);
      // The adjacent cards may not yet have been parsed during initial upgrade.
      queueMicrotask(() => { if (this.isConnected) this.refresh(); });
      this.timer = setInterval(() => this.refresh(), 60000);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      clearInterval(this.timer);
    }
    refresh() {
      this.cards = Array.from(this.parentElement.querySelectorAll('.variant-photo[data-stock-state]'));
      const now = Date.now() / 1000;
      this.cards.forEach(card => {
        if (card.dataset.stockState === 'remote' && Number(card.dataset.stockExpires) <= now) {
          card.dataset.stockState = 'soldout';
          card.querySelector('.variant-photo__stock').textContent = this.labels.find(([key]) => key === 'soldout')[1];
        }
      });
      const counts = Object.fromEntries(this.labels.map(([key]) => [key, key === 'all' ? this.cards.length : this.cards.filter(card => card.dataset.stockState === key).length]));
      const selected = selections.get(this.dataset.key) || 'all';
      this.select.replaceChildren(...this.labels.filter(([key]) => counts[key] > 0).map(([key, label]) => new Option(`${label} (${counts[key]})`, key)));
      this.select.value = counts[selected] ? selected : 'all';
      selections.set(this.dataset.key, this.select.value);
      this.hidden = this.cards.length < 2;
      this.apply();
    }
    apply() {
      let selectedHidden = false;
      this.cards.forEach(card => {
        const hidden = this.select.value !== 'all' && card.dataset.stockState !== this.select.value;
        card.hidden = hidden;
        const input = card.previousElementSibling;
        input.hidden = hidden;
        input.tabIndex = hidden ? -1 : 0;
        if (input.checked && hidden) selectedHidden = true;
      });
      this.querySelector('[data-filter-notice]').hidden = !selectedHidden;
    }
  });
}
